import { RedoFulfillmentToteSchema } from "@redotech/redo-fulfillment-group-common/fulfillment-tote";
import { locationIdFormat } from "@redotech/redo-inventory-id";
import * as z from "zod";

export const getToteByBarcode = {
  name: "getToteByBarcode" as const,
  input: z.object({
    barcode: z.string().max(255),
    locationId: locationIdFormat.schema.nullish(),
  }),
  output: RedoFulfillmentToteSchema,
};

export type GetToteByBarcodeInput = z.infer<typeof getToteByBarcode.input>;
